<template>
  <div>
    <div
      class="inline-flex justify-center items-center py-5 px-3 mt-2 mb-3 w-full h-8 text-sm font-medium leading-none text-violet-vivid-500 rounded-sm cursor-pointer select-none shadow bg-violet-050 border border-violet-vivid-500"
      style="cursor: pointer;"
    >
      {{text}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'actionButton',
    props: {
      text:String,
    },
    computed:{
    },
    methods:{
    }
  };
</script>

<style>

</style>